import { render } from "./SafeNav.vue?vue&type=template&id=8264d1a0&scoped=true"
import script from "./SafeNav.vue?vue&type=script&lang=js"
export * from "./SafeNav.vue?vue&type=script&lang=js"

import "./SafeNav.vue?vue&type=style&index=0&id=8264d1a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8264d1a0"]])

export default __exports__